export const WAPP_DEV_ENV_WAPP_ID = 'wapp-dev-environment'
export const WAPP_DEV_ENV_SRC_URL = 'http://localhost:3000'
